import ProfilePic from '@/components/shared/ProfilePic/ProfilePic';
import AppState, { POPUPS } from '@/js/AppState';
import clsx from 'clsx';
import { observer } from 'mobx-react-lite';
import { FaUser } from "react-icons/fa6";
import classes from './ChapterBar.module.css';

import star from '../../../images/star.png';
import { useEffect, useState } from 'react';
import { Tooltip } from 'react-tooltip'
import PopupsManager from 'react-sdk/PopupsManager';
import Shepherd from 'shepherd.js';
import { toJS } from 'mobx';


const ChapterBar = () => {

  const [mainObjectives, setMainObjectives] = useState([])
  const [objectivesCollections, setObjectivesCollections] = useState([])

  useEffect(() => {
    setMainObjectives([])

    AppState.soloObjectives.objectives.forEach(obj => {
      if (obj.parent === null) {
        setMainObjectives(mainObjectives => [...mainObjectives, obj])
      }
    });
  }, [])

  useEffect(() => {

    const coll = []

    AppState.soloObjectives.objectives.forEach(obj => {
      if (obj.parent === null) {
        coll.push([obj])
      }
      else {
        coll[coll.length - 1].push(obj)
      }
    });
    setObjectivesCollections(coll)
  }, [AppState.soloObjectives.objectives])

  const getObjectiveType = (obj) => {
    if (obj.parent === null) {
      return "main"
    }
    if (obj.children.length > 0) {
      return "sub"
    }
    else {
      return "small"
    }
  }



  return (
    <div className={classes.ChapterBar}>
      <div className={classes.nameContainer}>
        {
          mainObjectives.map((o, i) => (<div key={`name-${i}`} className={`${classes.chapter_name} ${classes[o.id]} ${classes[o.state]}`}>{o.name}</div>))
        }
      </div>
      <div className={classes.bar}>
        {
          [...objectivesCollections]
            .map((coll, index) => (
              <div key={index} className={classes.chapter}>
                {
                  coll.sort((a, b) => {
                    if (a.parent === null || b.parent === null) return 0;
                    if (a.state === "ACTIVE" && (b.state === "COMPLETED" || b.state === "FINISHED")) return 1;
                    if (b.state === "ACTIVE" && (a.state === "COMPLETED" || a.state === "FINISHED")) return -1;
                    return 0;
                  }).map((o, index) => (
                    <div key={o.id} className={`${classes.bar_item} ${classes[getObjectiveType(o)]} ${classes[o.state]}`} />
                  ))
                }
              </div>
            ))
        }
        <div className={`${classes.bar_item} ${classes.main}`} />
      </div>
    </div>
  );
};

export default observer(ChapterBar);
